<template lang="pug">
.d-flex.justify-space-between.gap-16.rounded-16.relative(
  :class="containerClass"
)
  v-overlay.filter-blur-1.rounded-16(
    v-if="loading"
    absolute
    color="redesignBackground"
    opacity="0.4"
    :z-index="10"
  )
    v-progress-circular(
      color="redesignPrimary"
      indeterminate
    )
  .d-grid.relative.full-width
    slot(name="default" v-bind="{ isEditing, switchEditingMode, loading }")
  .d-flex.justify-space-between(
    :class="{ 'order-first': !vertical }"
  )
    slot(name="title" v-bind="{ isEditing, switchEditingMode, loading }")
    .d-flex.gap-16(
      v-if="showButtons"
      :class=`{
        'justify-start flex-row': !vertical,
        'flex-column justify-center': vertical,
      }`
    )
      slot(name="prependActions" v-bind="{ isEditing, switchEditingMode, loading }")
      template(v-for="button in activeButtons")
        app-button.px-0.rounded-12(
          v-if="button.condition"
          :key="button.id"
          :disabled="loading"
          :color="button.backgroundColor"
          @click="button.action"
          min-width="40px"
          height="40px"
          :class="{ 'px-0': !button.text, 'px-3': button.text, 'section-bg-alternative': alternativeBg }"
        )
          v-icon(:color="button.iconColor" :size="button.id === BUTTONS_TYPES.REJECT ? 24 : 20") {{ button.icon }}
          .body-1.mx-1(v-if="button.text" :class="`${button.iconColor}--text`") {{ button.text }}
      slot(name="appendActions" v-bind="{ isEditing, switchEditingMode, loading }")
</template>

<script>
import AppButton from '@/components/user-redesign/controls/AppButton.vue';

export const BUTTONS_TYPES = {
  EDIT: 0,
  ACCEPT: 1,
  REJECT: 2,
};

export default {
  name: 'AppEditableContent',
  components: {
    AppButton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    availableButtons: {
      type: Array,
      default: () => Object.values(BUTTONS_TYPES),
    },
    editingBackground: {
      type: String,
      default: 'white',
    },
    actionButtonsBackground: {
      type: String,
      default: 'redesignBackground',
    },
    acceptBeforeDestroy: {
      type: Boolean,
      default: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    buttonsText: {
      type: Boolean,
      default: false,
    },
    alternativeBg: {
      type: Boolean,
      defailt: false,
    },
  },

  data() {
    return {
      BUTTONS_TYPES,
      isEditing: false,
    };
  },

  computed: {
    containerClass() {
      const currentClass = [];
      if (!this.vertical) currentClass.push('flex-column');
      if (this.isEditing) currentClass.push(this.editingBackground);
      return currentClass;
    },
    buttons() {
      return [
        {
          id: BUTTONS_TYPES.EDIT,
          icon: '$ipencil',
          condition: !this.isEditing,
          backgroundColor: this.actionButtonsBackground,
          iconColor: 'redesignPrimaryDarken',
          action: () => this.switchEditingMode(),
        },
        {
          id: BUTTONS_TYPES.ACCEPT,
          icon: 'mdi-check',
          condition: this.isEditing,
          backgroundColor: this.actionButtonsBackground,
          iconColor: 'redesignSuccess',
          text: this.buttonsText ? 'Сохранить' : '',
          action: () => this.accept(),
        },
        {
          id: BUTTONS_TYPES.REJECT,
          icon: '$iclose',
          condition: this.isEditing,
          backgroundColor: this.actionButtonsBackground,
          iconColor: 'redesignError',
          action: () => this.reject(),
        },
      ];
    },
    activeButtons() {
      return this.buttons.filter((button) => this.availableButtons.includes(button.id));
    },
  },

  beforeDestroy() {
    if (this.acceptBeforeDestroy && this.isEditing) this.accept();
  },

  methods: {
    accept() {
      this.$emit('accept');
      this.switchEditingMode();
    },
    reject() {
      this.$emit('reject');
      this.switchEditingMode();
    },
    switchEditingMode() {
      this.isEditing = !this.isEditing;
      this.$emit('switchEditing', this.isEditing);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
